// @flow

import { combineReducers } from 'redux-immutable';

import arquivos from './arquivos';
import documentos from './documentos';
import escriturados from './escriturados';

export default combineReducers({ arquivos, documentos, escriturados });